import { Action } from '@ngrx/store';
import { ContactType } from '../../business-objects/contact-type/contact-type.model';
import { Contact } from '../../business-objects/contact/contact.model';
import {IFilterFormValue} from "./contact-picker.reducer";

export const ACTION_LOAD_CONTACTS = '[Contacts] Load';
export const ACTION_LOAD_CONTACTS_SUCCESS = '[Contacts] Load Success';
export const ACTION_LOAD_CONTACTS_TYPES = '[Contacts Types] Load';
export const ACTION_LOAD_CONTACTS_TYPES_SUCCESS = '[Contacts Types] Load Success';
export const ACTION_SET_CONTACTS_FILTER = '[Contacts Picker] Set Filter';

export class ActionLoadContacts implements Action {
    readonly type = ACTION_LOAD_CONTACTS;
    readonly payload = undefined;
}

export class ActionLoadContactsSuccess implements Action {
    readonly type = ACTION_LOAD_CONTACTS_SUCCESS;

    constructor(public payload: Array<Contact>) {}
}

export class ActionLoadContactTypes implements Action {
    readonly type = ACTION_LOAD_CONTACTS_TYPES;
    readonly payload = undefined;
}

export class ActionLoadContactTypesSuccess implements Action {
    readonly type = ACTION_LOAD_CONTACTS_TYPES_SUCCESS;

    constructor(public payload: Array<ContactType>) {}
}

export class ActionSetContactsFilter implements Action {
    readonly type = ACTION_SET_CONTACTS_FILTER;

    constructor(public payload: IFilterFormValue) {}
}

export type ContactPickerActionType =
    ActionLoadContacts |
    ActionLoadContactsSuccess |
    ActionLoadContactTypes |
    ActionLoadContactTypesSuccess |
    ActionSetContactsFilter;



// WEBPACK FOOTER //
// ./src/vas/pages/contact-picker/contact-picker.actions.ts